import React, { useEffect, useState } from "react";
import "./OverlaySlides.scss";
import { useOverlaySubject } from "../../../hooks/useOverlaySubject";
import { ISlideContent } from "../../../interfaces/SlideContent";
import { useTranslation } from "react-i18next";
import { OverlaySlide } from "./OverlaySlide/OverlaySlide";
import { useDrAce } from "../../../hooks/useDrAce";
import sales1 from "../../../assets/img/Sales.jpg"
import sales2 from "../../../assets/img/Sales.2.jpg"
import production1 from "../../../assets/img/Bereiden1.jpg"
import production2 from "../../../assets/img/Bereiden2.jpg"
import production3 from "../../../assets/img/Bereiden_Lab.jpg"
import production4 from "../../../assets/img/Bereiden_Lab (2).jpg"
import warehouse1 from "../../../assets/img/Verpakken.jpg"
import warehouse2 from "../../../assets/img/Warehouse & Logistics.jpg"
import warehouse3 from "../../../assets/img/Warenhouse & logistics1.jpg"
import { IDrAce } from "../../../interfaces/DrAce";
import { shuffle } from "lodash";

interface IProps {

}

const aceContents: IDrAce[] = [{
    icon: 'pill',
    text: 'Vergeet uw Ace goodies niet mee te nemen!'
}, {
    icon: 'lightning',
    text: 'Heeft u al een foto gemaakt met mij? Ga naar de photobooth op deze stand.'
}, {
    icon: 'plus',
    text: 'Bent u geïnteresseerd in het schappenplan van Ace? Vraag het aan onze accountmanagers, zij zijn aanwezig op de stand.'
}, {
    icon: 'lightning',
    text: 'Heeft u de Ace Nerve Game al gespeeld? Ga de uitdaging aan!',
}, {
    icon: 'pill',
    text: 'Wilt u meer weten over de mogelijkheden van Ace? Onze medewerkers op de stand helpen u graag verder.',
}, {
    icon: 'pill',
    text: 'Wist u dat Desirée ook aanwezig is op de stand? Heeft u haar al gesproken?',
}, {
    icon: 'barcode',
    text: 'Test uw vaardigheden bij de Ace Game aan de achterkant van onze stand! Vul uw naam en score in en maak kans op een Ace verrassingspakket.',
}, {
    icon: 'pill',
    text: 'Heeft u de neutrale dermatica van Ace nog niet opgenomen in uw assortiment? Vraag het aan onze medewerkers op de stand.',
}, {
    icon: 'plus',
    text: 'Ook Chaimae is vandaag aanwezig op onze stand. Ze vertelt u graag meer over onze service.',
}]

export const slideContent: {[key: string]: ISlideContent[]} = {
    en: [
        {
            title: 'Welcome',
            key: 'welcome',
            content: 'lipsum',
        },
        {
            title: 'No way',
            key: 'sales',
            content: 'lipsum',
            images: [
                sales1,
                sales2
            ]
        },
        {
            title: 'No way',
            key: 'production',
            content: 'lipsum',
            images: [
                production1,
                production2,
                production3,
                production4,
            ]
        },
        {
            title: 'No way',
            key: 'warehousing',
            content: 'lipsum',
            images: [
                warehouse1,
                warehouse2,
                warehouse3,
            ]
        },
    ],
    nl: [
        {
            title: 'Welkom bij ACE',
            altTitle: 'Welkom',
            key: 'welcome',
            content: '<p>Ace Pharmaceuticals is een dynamisch bedrijf met oneindig veel kennis op het gebied van productie, laboratorium en kwaliteitsmanagement. Wij maken zowel geregistreerde als niet geregistreerde producten. Door de innovatieve ontwikkelingen op het gebied van geneesmiddelen wordt er steeds meer maatwerk geneeskunde gevraagd. Ace maakt geneesmiddelen voor een nichemarkt zodat deze beschikbaar blijven voor kleine groepen patiënten.</p>',
        },
        {
            title: 'Klantenservice & Sales',
            key: 'sales',
            content: '<p>Onze klanten staan centraal in alles wat we doen bij Ace. Ons klantenserviceteam is toegewijd om klanten te voorzien van de best mogelijke service en oplossingen en is beschikbaar om vragen te beantwoorden en te helpen bij bestellingen. Of het nu gaat om het plaatsen van een bestelling, het volgen van een zending of vragen over ons DB en indifferent assortiment, ons team staat klaar om te helpen. Ook zijn onze accountmanagers dagelijks door heel Nederland actief om u te informeren en te ondersteunen in het advies aan uw klanten.</p>',
            images: [
                sales1,
                sales2
            ]
        },
        {
            title: 'Productie',
            key: 'production',
            content: `<p>In onze GMP-productiefaciliteit worden geneesmiddelen gemaakt en in het laboratorium getest of ze aan de kwaliteitseisen voldoen. De apothekers bij Ace zorgen er voor dat de geneesmiddelen volgens protocol gemaakt worden en waarborgen een streng gereguleerd proces waarbij het naleven van protocollen en het uitvoeren van controles erg belangrijk is. Als er is gecontroleerd of de productie van het geneesmiddel voldoet aan de farmaceutische kwaliteiten, neemt de afdeling Quality het over. Zij controleren op compliance en kijken of het hele proces (van inkoop tot analyse) voldoet aan goede farmaceutische kwaliteit.</p><p>Als de productie gereed is worden de geneesmiddelen verpakt. Bij de afdeling Primair gaan de geneesmiddelen gaan in blisters of in potjes en dan door naar de afdeling Secundair. Hier komt de bijsluiter er bij en gaat er soms een etiket op de verpakking. De producten gaan vervolgens op de check weigher en het juiste aantal per verpakking wordt gecontroleerd.</p>`,
            images: [
                production1,
                production2,
                production3,
                production4,
            ]
        },
        {
            title: 'Warehousing & Logistics',
            key: 'warehousing',
            content: `<p>Als geneesmiddelen door productie zijn verpakt worden ze overgedragen aan Warehouse &amp; Logistics. De geneesmiddelen worden daar gecontroleerd op het juiste aantal, artikel- en chargenummer en worden dan opgeslagen in quarantaine, totdat de afdeling Quality Assurance (QA) alles zorgvuldig heeft gecontroleerd en vrijgegeven. Pas als een charge is vrijgegeven door QA, kunnen de orders worden verstuurd.</p><p>Orders komen binnen via Klantenservice &amp; Sales en worden na controle vrijgegeven voor de orderpicking en verzending. Een gedeelte van de geneesmiddelen wordt direct door onze medewerkers gepicked in het magazijn en een andere gedeelte komt uit onze opslag en picking robot ‘Knapp’. Alles wordt samengevoegd, nog een keer gecontroleerd en dan verpakt voor de verzending naar de klanten. Alle orders die tot 17.00 uur binnenkomen worden dezelfde dag klaargezet voor verzending. Dagelijks gaan alle bestellingen rond 19.00 uur op transport naar verschillende distributiecentra van onze logistieke partners over de hele land om in de ochtend te bezorgen bij onze klanten.</p>`,
            images: [
                warehouse1,
                warehouse2,
                warehouse3,
            ]
        },
    ]
};

export function OverlaySlides(props: IProps) {
    const { i18n } = useTranslation();
    const { setContent: setAceContent, content: aceContent } = useDrAce();
    const { subject, setSubject } = useOverlaySubject();
    const [hiding, setHiding] = useState(false);

    const content = slideContent[i18n.language] ?? [];
    const activeIndex = content.findIndex((value) => value.key === subject);
    const handleClose = () => {
        setSubject(undefined);
    }

    const visible = !!subject;

    // Reset after a minute
    useEffect(() => {
        if (!subject) return;
        let timeout = setTimeout(() => {
            setSubject(undefined);
        }, 60 * 1000);
        const resetTimeoutOnTouch = () => {
            console.log('cleared timeout bcz of touch');
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                setSubject(undefined)
            }, 60 * 1000);
        }
        window.addEventListener('pointerdown', resetTimeoutOnTouch);
        return () => {
            console.log('cleared timeout bcz of change');
            clearTimeout(timeout);
            window.removeEventListener('pointerdown', resetTimeoutOnTouch);
        }
    }, [subject, setSubject]);


    useEffect(() => {
        setHiding(true);
        const timeout = setTimeout(() => {
            setHiding(false);
        }, 500);
        return () => {
            clearTimeout(timeout);
        }
    }, [visible]);

    useEffect(() => {
        if (activeIndex < 0) return;
        if (!visible) return;
        // Every 20 sec, ACE comes up
        const timeout = setTimeout(() => {
            const aceContent = shuffle(aceContents)[0];
            setAceContent(aceContent);
        }, 20000);
        return () => {
            clearTimeout(timeout);
        }
    }, [aceContent, activeIndex, setAceContent, visible]);

    const goToSlide = (index: number): { buttonText: string, buttonHandle: () => void } => {
        const newSlide= content[index];
        return {
            buttonText: newSlide.title,
            buttonHandle: () => {
                const newSlide= content[index];
                setSubject(newSlide.key);
                console.log('MOVING TO SLIDE', newSlide.title);
            }
        }
    }

    return (
        <>
            <div className={`overlay-slides-wrapper ${visible ? 'visible' : ''} ${hiding ? 'hiding' : ''}`}>
                <div className="overlay-slides-container" data-active={activeIndex}>
                    {content.map((slideContent, index) => {
                        return <OverlaySlide content={slideContent} key={index} onClose={handleClose} closeOnPrevious={index === 0} {...{
                            ...(index > 0 ? {
                                onPrevious: goToSlide(index - 1),
                            } : {}),
                            ...(index < (content.length - 1) ? {
                                onNext: goToSlide(index + 1),
                            } : {})
                        }} />;
                    })}
                </div>
            </div>
            {/*<Image3DSlider imageSet={content.map((value) => value.images ?? [])} active={activeIndex} />*/}
        </>
    )
}
